import { AlertTriangle } from "lucide-react";
import { money, fmtKST } from "@/lib/api";

const left = (b) => Math.max(0, Math.round((b.owed - b.paid - b.pending) * 100) / 100);

const daysLeft = (iso) => {
  const d = Math.floor((new Date(iso) - Date.now()) / 86400000);
  return d < 1 ? "less than 1 day" : `${d} day${d === 1 ? "" : "s"}`;
};

const LateFeeNote = ({ b }) => (
  <p data-testid={`past-due-late-fee-${b.key.slice(2)}`} className="basis-full text-red-100">
    {money(b.late_fees)} of Late Fees have been applied for {b.late_claims} {b.late_claims === 1 ? "claim" : "claims"} at this time.
    {b.drop_at && <> You have <span className="font-semibold">{daysLeft(b.drop_at)} left</span> to pay before your claim is dropped.</>}
  </p>
);

export const PastDueAlert = ({ dropBalances = [], specialBalances = [], onPay }) => {
  const items = [
    ...dropBalances.filter((b) => b.past_due).map((b) => ({ key: `d:${b.drop_id}`, name: b.title, ...b })),
    ...specialBalances.filter((b) => b.past_due).map((b) => ({ key: `s:${b.special_drop_id}`, ...b })),
  ];
  if (!items.length) return null;
  const payTo = items[0].pay_to;
  const total = items.reduce((s, b) => s + left(b), 0);
  return (
    <div data-testid="past-due-alert" className="mt-6 rounded-2xl border border-red-500/40 bg-red-500/[0.08] p-4 sm:p-5">
      <button type="button" data-testid="past-due-button" onClick={() => onPay(items.filter((b) => b.pay_to === payTo).map((b) => b.key))}
        className="inline-flex items-center gap-2 rounded-full bg-red-500 px-4 py-2 text-sm font-bold text-white shadow-lg shadow-red-500/20 animate-pulse hover:animate-none hover:bg-red-400 transition-colors">
        <AlertTriangle className="h-4 w-4" /> Initials Past Due!
      </button>
      <p className="mt-3 text-sm text-red-100">The payment due date has passed for {items.length === 1 ? "this drop" : "these drops"} and we haven't received your payment. Total {money(total)}.</p>
      <ul className="mt-2 space-y-2 text-xs" data-testid="past-due-list">
        {items.map((b) => (
          <li key={b.key} data-testid={`past-due-${b.key.slice(2)}`} className="flex flex-wrap gap-x-2 text-red-200/90">
            <span className="font-semibold">{b.name}</span>
            <span className="font-mono">{money(left(b))}</span>
            <span className="text-red-300/70">due {fmtKST(b.payment_due)}</span>
            {b.late_claims > 0 && <LateFeeNote b={b} />}
          </li>
        ))}
      </ul>
    </div>
  );
};
